export const SET_FILTERS = "SET_FILTERS";

export const CLEAR_FILTERS = "CLEAR_FILTERS";

export const SET_PROPERTIES = "SET_PROPERTIES";
